import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Interruptor } from '@/shared/ui/Interruptor';

const COLORES = {
  marca: 'bg-marca-100 text-marca-700',
  azul: 'bg-blue-100 text-blue-700',
  ambar: 'bg-amber-100 text-amber-700',
  violeta: 'bg-violet-100 text-violet-700',
} as const;

export type ColorDeTitulo = keyof typeof COLORES;

export function Titulo({
  icono: Icono,
  color,
  texto,
}: {
  icono: LucideIcon;
  color: ColorDeTitulo;
  texto: string;
}) {
  return (
    <h2 className="flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-armazon-800">
      <span className={`grid size-6 shrink-0 place-items-center rounded-md ${COLORES[color]}`}>
        <Icono className="size-3" aria-hidden />
      </span>
      {texto}
    </h2>
  );
}

export function Campo({
  etiqueta,
  error,
  ayuda,
  requerido = false,
  ancho = 'mitad',
  children,
}: {
  etiqueta: string;
  error?: string | undefined;
  ayuda?: string | undefined;
  requerido?: boolean;
  ancho?: 'mitad' | 'completo';
  children: ReactNode;
}) {
  return (
    <label className={`grid content-start gap-1.5 ${ancho === 'completo' ? 'sm:col-span-2' : ''}`}>
      <span className="text-xs font-semibold uppercase tracking-wider text-armazon-600">
        {etiqueta}
        {requerido && <span className="ml-0.5 text-alerta">*</span>}
      </span>
      {children}
      {error ? (
        <span role="alert" className="text-sm text-alerta">
          {error}
        </span>
      ) : (
        ayuda && (
          <span className="text-[11px] uppercase tracking-[0.03em] text-armazon-600">{ayuda}</span>
        )
      )}
    </label>
  );
}

export const entrada =
  'h-11 w-full rounded-lg border border-armazon-200 bg-white px-3 text-sm text-armazon-900 outline-none transition-colors placeholder:text-armazon-400 focus:border-marca-400 focus:ring-2 focus:ring-marca-500/20';

export function Marca({
  etiqueta,
  nota,
  activo,
  alCambiar,
}: {
  etiqueta: string;
  nota: string;
  activo: boolean;
  alCambiar: () => void;
}) {
  return (
    <div className="flex items-center justify-between gap-3 rounded-xl border border-armazon-200 bg-armazon-50/60 p-4">
      <div className="min-w-0">
        <p className="text-sm font-medium uppercase text-armazon-800">{etiqueta}</p>
        <p className="mt-0.5 text-[10px] uppercase text-armazon-600">{nota}</p>
      </div>
      <Interruptor activo={activo} alCambiar={alCambiar} etiqueta={etiqueta} />
    </div>
  );
}
